import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { createI18nText } from '../../functions';
var formText = createI18nText({
    he: {
        chooseDate: 'בחר תאריך',
        uploadFile: 'העלה קובץ',
        fileType: 'על הקובץ להיות קובץ מסוג',
        formImage: {
            drag: _jsxs(_Fragment, { children: ["\u05D2\u05E8\u05D5\u05E8 \u05EA\u05DE\u05D5\u05E0\u05D4 \u05DC\u05DB\u05D0\u05DF", _jsx("br", {}, void 0), "\u05D0\u05D5"] }, void 0),
            noImage: 'אין תמונה',
            addImage: 'הוסף תמונה',
            type: 'על התמונה להיות קובץ מסוג'
        },
        choose: 'בחר',
        chooseTimeRange: 'בחר טווח שעות',
        chooseTime: 'בחר זמן'
    },
    en: {
        chooseDate: 'Choose a date',
        uploadFile: 'Upload file',
        fileType: 'The file must be a file of type',
        formImage: {
            drag: _jsxs(_Fragment, { children: ["Drag an image here", _jsx("br", {}, void 0), "or"] }, void 0),
            noImage: 'No image',
            addImage: 'Add image',
            type: 'The image must be a file of type'
        },
        choose: 'Choose',
        chooseTimeRange: 'Choose a time span',
        chooseTime: 'Choose a time'
    }
});
export default formText;
//# sourceMappingURL=formText.js.map